import * as z from 'zod'

import { ValidationRegexs } from '@/types/validation-regexs'

import { validateMultiLangNumbers } from '../_utils/validate-multi-lang-numbers'

export const ContactUsFormValidation = z.object({
    fullName: z
        .string({ required_error: 'این قسمت را خالی نگذارید.' })
        .nonempty('این قسمت را خالی نگذارید.')
        .max(50, 'تعداد کاراکترهای نام و نام خانوادگی بیشتر از حد مجاز است.')
        .regex(ValidationRegexs.persianArabicCharacters, 'لطفااز حروف فارسی استفاده کنید.'),
    phone: z
        .string({ invalid_type_error: 'شماره موبایل وارد شده نادرست است.' })
        .nonempty('این قسمت را خالی نگذارید.')
        .max(11, 'شماره موبایل باید ۱۱ رقم باشد.')
        .refine((value) => validateMultiLangNumbers(value, ValidationRegexs.baseMobileNumber), {
            message: 'شماره موبایل وارد شده نادرست است.',
        }),
    emailAddress: z
        .string()
        .refine((value) => value === '' || value === null || ValidationRegexs.emailValidation.test(value), {
            message: 'ایمیل وارد شده نامعتبر است. ',
        })
        .nullable(),
    message: z
        .string()
        .max(500, 'تعداد کاراکترهای وارد شده بیش از حد مجاز است.')
        .min(5, 'متن پیام باید حداقل ۵ کاراکتر باشد.'),
})
